import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs';
import { IDrawingScheduleAdherenceInputModel } from 'src/app/ViewModel/Report.Model';
import { environment } from 'src/environments/environment';
import { CommonService } from '../Common.service';
import { EncryptDecryptService } from '../encrypt-decrypt.service';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ReportService {
  private Url_GetDrawingScheduleAdherenceList = 'Report/GetDrawingScheduleAdherenceList';
  private Url_GetSCurveDetails = 'Report/GetSCurveDetails';
  private Url_GetStatusWiseCompletionPercentage = 'Report/GetStatusWiseCompletionPercentage';
  private Url_UpdateStatusWiseCompletionPercentage = 'Report/UpdateStatusWiseCompletionPercentage';
  private Url_GetSCurveExportDetails = '/Report/GetSCurveExportDetails';

  constructor(private restAPIService: RestApiService, private commonService: CommonService, private encryptDecryptService: EncryptDecryptService, private http: HttpClient) { }

  public GetDrawingScheduleAdherenceList(commInp: any): Observable<any> {
    return this.restAPIService.new_POST(this.Url_GetDrawingScheduleAdherenceList, commInp);
  }

  public GetSCurveDetails(Input: any): Observable<any> {
    return this.restAPIService.new_POST(this.Url_GetSCurveDetails, Input);
  }

  public GetSCurveExportDetails(Input: any): Observable<any> {
    let _apiURL = environment.uriHost + this.Url_GetSCurveExportDetails;
    const headers = {
      'X-Requested-With': 'XMLHttpRequest',
      'Authorization': 'Bearer ' + this.commonService.getJWT(),
      'loginAuditNumber': this.encryptDecryptService.decrypt(this.commonService.getLoginAuditNumber())
    }
    return this.http.post(_apiURL, Input, { 'headers': headers, responseType: 'blob' });
  }

  public GetStatusWiseCompletionPercentage(Input: any): Observable<any> {
    return this.restAPIService.new_POST(this.Url_GetStatusWiseCompletionPercentage, Input);
  }

  public UpdateStatusWiseCompletionPercentage(Input: any): Observable<any> {
    return this.restAPIService.new_POST(this.Url_UpdateStatusWiseCompletionPercentage, Input);
  }
}
